/**
 * This file is part of ONP.
 *
 * Copyright (c) 2013 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Andrey Tkachenko <andrey.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'underscore', 'backbone'], function($, _, backbone) {
    var flashMessageTpl = _.template(
        '<div class="alert alert-<%= type %>">' + '<a class="close" data-dismiss="alert">×</a>' + '<%= message %>' + '</div>'
    );

    return backbone.View.extend({
        _elements: null,

        ZINDEX_NAVBAR: 98,

        initialize: function() {
            this._elements = this._scanElements(this.$body);
        },

        find: function(name) {
            return this._elements.all[name] || this._elements.tree[name];
        },

        _scanElements: function() {
            var all = {},
                tree = {};

            _.each(this.$body.find('[data-tag]'), function(el) {
                var $el = $(el);
                var prefix = $el
                    .closest('[data-tag]')
                    .map(function() {
                        return $(this).attr('data-tag');
                    })
                    .get()
                    .join('.');

                all[$el.attr('data-tag')] = $el;
                tree[prefix + '.' + $el.attr('data-tag')] = $el;
            });

            return { all: all, tree: tree };
        },

        showFlashMessage: function(message, type, $container) {
            var messageType = type || 'danger';
            var $messageContainer = $container || $('.flash-message');

            $messageContainer.prepend(flashMessageTpl({ type: messageType, message: message }));
        },

        /**
         * Returns height of the header in pixels if it's has fixed position
         *
         * @returns {number}
         */
        getFixedHeaderHeight: function() {
            var $header = $('#mobile-header');
            if ($header.css('position') === 'fixed') {
                return $header.outerHeight();
            }

            return 0;
        },

        /**
         * @returns {number}
         */
        getHeaderHeight: function() {
            return $('#header').outerHeight();
        }
    });
});
